import {BaseApiTemplateService, Core2Config} from "../../../shared";
import {AgentVirtualContactSquadContactContainerModel} from "../../../../../../../models/aggregates/alg/cc/link";
import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";

@Injectable({providedIn: 'root'})
export class AgentVirtualContactSquadContactService extends BaseApiTemplateService<AgentVirtualContactSquadContactContainerModel>{
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'agent-vc-squad-contact-links';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'agent-vc-squad-contact-links';
    this.httpClient = http;
  }
}
